module.exports = __webpack_public_path__ + "images/icon/ExrternalLink-8f360be0.svg";